var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useCallback, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { SlideControls } from '../elements/slide-controls';
import { useSwipeable } from 'react-swipeable';
import { useReady } from '../hooks/use-ready';
import { get, first } from 'lodash';
import { useSpring, animated } from '@react-spring/web';
import { useEntityTypeBanners } from '../hooks/use-entity-type-banners';
import { LinkBanner } from './link-banner';
import { useSiteSearch } from '../hooks/use-site-search';
var cls = classNames('entity-carousel');
export var EntityCarouselDefaultProps = {
  slideInterval: 5000,
  initialIndex: 0,
  preload: true,
  fadeColor: '#111',
  fadeDuration: 300,
  showSlideControls: true,
  slideStyle: {},
  aspectRatio: {
    base: 4 / 3,
    desktop: 21 / 9,
    desktopLarge: 3
  },
  transitionType: 'fade'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n  "], ["\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n  "])))
});
var FadeStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 100%;\n    display: flex;\n    width: 100%;\n    flex: 0 0 100%;\n    ", "\n  "], ["\n    height: 100%;\n    display: flex;\n    width: 100%;\n    flex: 0 0 100%;\n    ", "\n  "])), function (_a) {
    var _color = _a._color;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme.COLOR(_color));
  })
});
var BannerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex: 0 0 100%;\n    box-sizing: border-box;\n    .shp--entity-banner__layout {\n      padding-bottom: ", ";\n    } \n  "], ["\n    flex: 0 0 100%;\n    box-sizing: border-box;\n    .shp--entity-banner__layout {\n      padding-bottom: ", ";\n    } \n  "])), theme.UNIT(13))
});
var SlideControlsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    bottom: ", ";\n    width: 100%;\n  "], ["\n    position: absolute;\n    bottom: ", ";\n    width: 100%;\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    bottom: ", ";\n  "], ["\n    bottom: ", ";\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Fade: styled.div.attrs(cls.attr('fade'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), FadeStyles),
  SlideControls: styled(SlideControls)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), SlideControlsStyles),
  BannerContainer: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles)
};
export var EntityCarousel = function (props) {
  var className = props.className,
    children = props.children,
    _a = props.items,
    items = _a === void 0 ? [] : _a,
    fadeDuration = props.fadeDuration,
    slideInterval = props.slideInterval,
    fadeColor = props.fadeColor,
    preload = props.preload,
    slideStyle = props.slideStyle,
    overlayColor = props.overlayColor,
    aspectRatio = props.aspectRatio,
    slideControls = props.slideControls,
    bannerProps = props.bannerProps,
    transitionType = props.transitionType;
  var _b = __read(useState(0), 2),
    itemIndex = _b[0],
    setItemIndex = _b[1];
  var _c = __read(useState(null), 2),
    nextIndex = _c[0],
    setNextIndex = _c[1];
  var _d = __read(useState(false), 2),
    fade = _d[0],
    setFade = _d[1];
  var isReady = useReady().isReady;
  var _e = __read(useState(null), 2),
    intervalId = _e[0],
    setIntervalId = _e[1];
  var search = useSiteSearch();
  var showSlideControls = items.length > 1 && props.showSlideControls;
  var slideStyles = useSpring({
    transform: "translateX(-".concat(itemIndex * 100, "%)"),
    config: {
      tension: 170,
      friction: 26
    },
    immediate: transitionType === 'fade'
  });
  var fadeStyles = useSpring({
    opacity: fade ? 0 : 1,
    config: {
      duration: fadeDuration
    },
    onRest: useCallback(function () {
      // once the fade out has stopped, change the image and fade in
      if (fade) {
        setItemIndex(nextIndex);
        setFade(false);
      }
    }, [fade, nextIndex]),
    immediate: transitionType === 'slide'
  });
  var showImage = function (index) {
    setNextIndex(index);
  };
  useEffect(function () {
    // when the next index changes, start the fade transition
    if (nextIndex !== null) {
      setFade(true);
    }
  }, [nextIndex]);
  var next = function () {
    var newIndex = itemIndex === items.length - 1 ? 0 : itemIndex + 1;
    setNextIndex(newIndex);
  };
  var prev = function () {
    var newIndex = itemIndex === 0 ? items.length - 1 : itemIndex - 1;
    setNextIndex(newIndex);
  };
  var handlers = useSwipeable({
    onSwipedLeft: function (eventData) {
      next();
    },
    onSwipedRight: function (eventData) {
      prev();
    }
  });
  useEffect(function () {
    if (isReady && items.length > 1 && !(search === null || search === void 0 ? void 0 : search.isVisible)) {
      var intervalId_1 = setInterval(next, slideInterval);
      setIntervalId(intervalId_1);
      return function () {
        return clearInterval(intervalId_1);
      };
    }
    if (search === null || search === void 0 ? void 0 : search.isVisible) {
      if (intervalId) {
        clearInterval(intervalId);
      }
    }
  }, [itemIndex, isReady, search === null || search === void 0 ? void 0 : search.isVisible]);
  var entity = get(items, "[".concat(itemIndex, "]"), first(items));
  var slideTransition = transitionType === 'fade' ? fadeStyles : slideStyles;
  var bannerComponents = useEntityTypeBanners();
  var BannerComponent = bannerComponents[entityTypeNameFor(entity)] || LinkBanner;
  return React.createElement("div", __assign({}, handlers, {
    style: {
      width: '100%'
    },
    className: cls.sub('swipeable')
  }), React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Fade, {
    _color: fadeColor,
    isOn: fade,
    durationInSeconds: fadeDuration / 1000
  }, React.createElement(animated.div, {
    style: __assign(__assign({}, slideTransition), {
      width: "100%",
      display: 'flex'
    })
  }, transitionType === 'slide' ? items.map(function (item) {
    var BannerComponent = bannerComponents[entityTypeNameFor(entity)] || LinkBanner;
    React.createElement(My.BannerContainer, null, React.createElement(BannerComponent, {
      customAspectRatio: aspectRatio,
      entity: item
    }));
  }) : React.createElement(My.BannerContainer, null, React.createElement(BannerComponent, {
    entity: entity
  })))), showSlideControls && isReady && React.createElement(My.SlideControls, {
    index: itemIndex,
    count: items.length,
    onPrev: prev,
    onNext: next,
    onSelect: showImage,
    style: slideStyle,
    showNavigationButtons: slideControls === null || slideControls === void 0 ? void 0 : slideControls.showNavigationButtons,
    variant: slideControls === null || slideControls === void 0 ? void 0 : slideControls.variant
  })));
};
EntityCarousel.defaultProps = EntityCarouselDefaultProps;
EntityCarousel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;